import { render, staticRenderFns } from "./NotAuthorized.vue?vue&type=template&id=1d08d295"
import script from "./NotAuthorized.vue?vue&type=script&lang=js"
export * from "./NotAuthorized.vue?vue&type=script&lang=js"
import style0 from "./NotAuthorized.vue?vue&type=style&index=0&id=1d08d295&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports